import { render, staticRenderFns } from "./CreateBillableItem.vue?vue&type=template&id=d5a80670&scoped=true"
import script from "./CreateBillableItem.vue?vue&type=script&lang=js"
export * from "./CreateBillableItem.vue?vue&type=script&lang=js"
import style0 from "./CreateBillableItem.vue?vue&type=style&index=0&id=d5a80670&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5a80670",
  null
  
)

export default component.exports